import "./work-slider.component.css"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import Glide, {
  Controls,
  Breakpoints,
  Swipe,
} from "@glidejs/glide/dist/glide.modular.esm"
import "@glidejs/glide/dist/css/glide.core.css"
import StrapiImageComponent from "../strapi-image/strapi-image.component"
import { daggerNavigate } from "../../utils/navigate.util"

const WorkSliderComponent = (props) => {
  const { Heading, Items, CtaButtonLabel, PageLink } = props
  const glideRef = useRef()
  const elRef = useRef()
  const sliderRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const el = sliderRef.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.unobserve(el)
        }
      },
      { threshold: 0.2 },
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const handleNav = (path, slug) => {
    let slugPath = path ? `/${path}/` : "/"
    slugPath += slug
    daggerNavigate(() => navigate(slugPath))
  }

  const createWorkItem = (item) => {
    return (
      <div
        key={item.id}
        data-item-id={item.id}
        className="dagger-work-item glide__slide"
      >
        <div className="dagger-item-hint">View Work</div>
        <div className="dagger-work-item-image" data-item-id={item.id}>
          <StrapiImageComponent
            attributes={
              item.CaseStudy.data.attributes.HeroImage.data.attributes
            }
            alt={item.CaseStudy.data.attributes.HeroCaption}
            sizes="(max-width: 800px) 100vw, 50vw"
          />
        </div>
        <h6>{item.CaseStudy.data.attributes.Client}</h6>
        {item.CaseStudy.data.attributes.HeroCaption && (
          <h5>{item.CaseStudy.data.attributes.HeroCaption}</h5>
        )}
      </div>
    )
  }

  useEffect(() => {
    if (!elRef.current) return
    const imageEl = elRef.current.querySelector(".dagger-work-item-image")
    if (imageEl && elRef.current?.style) {
      const observer = new ResizeObserver(() => {
        if (!elRef.current) return
        const center = imageEl.offsetHeight / 2
        elRef.current.style.setProperty("--controls-top", `${center}px`)
      })
      observer.observe(imageEl)
      return () => observer.disconnect()
    }
  }, [Items])

  useEffect(() => {
    if (Items?.length < 1 || glideRef.current || !elRef.current) return

    glideRef.current = new Glide(elRef.current, {
      type: "carousel",
      startAt: 0,
      perView: 2,
      focusAt: 0,
      peek: {
        before: 0,
        after: 150,
      },
      breakpoints: {
        800: {
          perView: 1,
          peek: 0,
        },
      },
    }).mount({ Controls, Breakpoints, Swipe })

    return () => {
      if (glideRef.current) {
        glideRef.current.destroy()
        glideRef.current = null
      }
    }
  }, [Items])

  const handleItemClick = (e) => {
    const slide = e.target.closest("[data-item-id]")
    if (slide) {
      const itemId = slide.getAttribute("data-item-id")
      const item = Items.find((i) => i.id.toString() === itemId)
      if (item) {
        handleNav("study", item.CaseStudy.data.attributes.Slug)
      }
    }
  }

  return (
    <div
      ref={sliderRef}
      className="dagger-work-slider"
    >
      <h6>{Heading}</h6>
      <div className={`glide ${isVisible ? "dagger-slide-in-visible" : "dagger-slide-in-hidden"}`} ref={elRef}>
        <div className="dagger-work-items glide__track" data-glide-el="track">
          <div className="glide__slides" onClick={handleItemClick}>
            {Items?.map((i, ind) => createWorkItem(i, ind))}
          </div>
        </div>
        <div data-glide-el="controls" className="glide-controls">
          <button data-glide-dir="<">
            <span className="prev-btn" />
          </button>
          <button data-glide-dir=">">
            <span className="next-btn" />
          </button>
        </div>
      </div>
      {CtaButtonLabel && PageLink?.data && (
        <button
          className="dagger-outline-btn"
          onClick={() => handleNav(null, PageLink.data.attributes.Slug)}
        >
          {CtaButtonLabel}
        </button>
      )}
    </div>
  )
}

export default WorkSliderComponent
